import React, { useState, useEffect } from "react";
import _ from "lodash";
import { Card, Typography } from "antd";
import { useTranslation } from "react-i18next";

const FeedBackForm = (props) => {
  const { t } = useTranslation();

  const { Paragraph } = Typography;

  const { selectedRecord, openModal } = props;

  return (
    <div>
      <Card title={t("common.title")}>
        <p>{selectedRecord.feedback_title}</p>
      </Card>
      <Card title={t("common.content")}>
        <Paragraph>
          <div style={{ whiteSpace: "pre-line" }}>
            {selectedRecord.feedback_content}
          </div>
        </Paragraph>
        {/* <p>{selectedRecord.feedback_content}</p> */}
      </Card>
    </div>
  );
};

export default FeedBackForm;
